var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.5c-4.135 0-7.5 3.41-7.5 7.595-.027 6.123 7.215 11.2 7.5 11.405 0 0 7.527-5.282 7.5-11.4 0-4.19-3.365-7.6-7.5-7.6m0 11.4c-2.072 0-3.75-1.7-3.75-3.8S9.928 6.3 12 6.3s3.75 1.7 3.75 3.8-1.678 3.8-3.75 3.8"
  })));
};
export default SvgLocation;